/**
 * @file attachment-types.ts
 * @description Константы для типов файловых вложений в Task Manager приложении
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-18
 * @updated 2025-09-18
 * @dependencies []
 * @related-files ['src/types/attachment.ts', 'src/utils/data-helper.tsx']
 */

// КОНСТАНТЫ ТИПОВ ВЛОЖЕНИЙ - НОВАЯ АРХИТЕКТУРА - 2025-09-18

/**
 * Типы вложений по ID в системе
 */
export const ATTACHMENT_TYPE_IDS = {
    /** Файл (загруженный на сервер) */
    FILE: "1",
    /** Ссылка (внешний URL) */
    LINK: "2",
    /** Объект системы (внутренняя сущность) */
    SYSTEM_OBJECT: "3"
} as const;

/**
 * Типы вложений по $type в системе
 */
export const ATTACHMENT_TYPE_NAMES = {
    /** Основной тип всех вложений */
    ATTACHMENT: "Attachment",
    /** Перечисление типов вложений */
    ATTACHMENT_TYPE_ENUM: "EAttachmentType",
    /** Файл как строковый тип */
    FILE: "file",
    /** Ссылка как строковый тип */
    LINK: "link",
    /** Объект системы как строковый тип */
    OBJECT: "object"
} as const;

/**
 * Отображаемые названия типов вложений
 */
export const ATTACHMENT_TYPE_DISPLAY_NAMES = {
    [ATTACHMENT_TYPE_IDS.FILE]: "Файл",
    [ATTACHMENT_TYPE_IDS.LINK]: "Ссылка",
    [ATTACHMENT_TYPE_IDS.SYSTEM_OBJECT]: "Объект системы"
} as const;

/**
 * MIME типы для различных расширений файлов
 */
export const FILE_MIME_TYPES = {
    // Изображения
    'png': 'image/png',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'gif': 'image/gif',
    'svg': 'image/svg+xml',
    'webp': 'image/webp',

    // Документы
    'pdf': 'application/pdf',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'xls': 'application/vnd.ms-excel',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'ppt': 'application/vnd.ms-powerpoint',
    'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',

    // Архивы
    'zip': 'application/zip',
    'rar': 'application/x-rar-compressed',
    '7z': 'application/x-7z-compressed',
    'tar': 'application/x-tar',
    'gz': 'application/gzip',

    // Текстовые
    'txt': 'text/plain',
    'csv': 'text/csv',
    'json': 'application/json',
    'xml': 'application/xml',

    // Аудио/Видео
    'mp3': 'audio/mpeg',
    'wav': 'audio/wav',
    'mp4': 'video/mp4',
    'avi': 'video/x-msvideo',
    'mov': 'video/quicktime'
} as const;

/**
 * Максимальные размеры файлов по типам (в байтах)
 */
export const FILE_SIZE_LIMITS = {
    /** Изображения - 10MB */
    IMAGE: 10 * 1024 * 1024,
    /** Документы - 50MB */
    DOCUMENT: 50 * 1024 * 1024,
    /** Архивы - 100MB */
    ARCHIVE: 100 * 1024 * 1024,
    /** Видео - 500MB */
    VIDEO: 500 * 1024 * 1024,
    /** По умолчанию - 25MB */
    DEFAULT: 25 * 1024 * 1024
} as const;

/**
 * Допустимые расширения файлов для загрузки
 */
export const ALLOWED_FILE_EXTENSIONS = [
    // Изображения
    'png', 'jpg', 'jpeg', 'gif', 'svg', 'webp',
    // Документы
    'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
    // Архивы
    'zip', 'rar', '7z', 'tar', 'gz',
    // Текстовые
    'txt', 'csv', 'json', 'xml',
    // Аудио/Видео
    'mp3', 'wav', 'mp4', 'avi', 'mov'
] as const;